// shop-frontend/src/utils/sizeUtils.js
// Single source of truth for "is this option value a size?"
// Used by mall variant expansion, product cards, and detail pages.
//
// Accepts:
//   • Letter sizes:  xs, s, m, l, xl, xxl, xxxl, 2xl, 3xl, 4xl, 5xl
//   • Word sizes:    small, medium, large, x-large, xx-large
//   • Numeric:       8, 10, 10.5, 36
//   • Numeric+unit:  10cm, 5kg, 12in, 2.5oz, 1lb
//   • Shoe sizes:    "US 10.5", "EU 42", "UK 8"
//   • One-size:      "One Size", "OS", "Free Size", "FS"
export const SIZE_RE = /^(xs|s|m|l|xl|xxl|xxxl|2xl|3xl|4xl|5xl|small|medium|large|x-large|xx-large|\d+(?:\.\d+)?(?:\s*(?:cm|mm|in|inch|kg|g|oz|lb|lbs))?|(?:us|eu|uk)\s*\d+(?:\.\d+)?|one\s*size|os|free\s*size|fs)$/i;

export const looksLikeSize = (v) => SIZE_RE.test(String(v || "").trim());
export const looksLikeSizes = (vals) =>
  Array.isArray(vals) && vals.length > 0 && vals.every(looksLikeSize);
